<script lang="ts" setup>
import { useId } from "radix-vue";
import { twMerge } from "tailwind-merge";
import { type HTMLAttributes, normalizeClass, provide } from "vue";

import { FORM_ITEM_INJECTION_KEY } from "./injectionKeys.ts";

const props = defineProps<{
	class?: HTMLAttributes["class"];
}>();

const id = useId();
provide(FORM_ITEM_INJECTION_KEY, id);
</script>

<template>
	<div :class="twMerge('space-y-2', normalizeClass(props.class))">
		<slot />
	</div>
</template>
